// extracted by mini-css-extract-plugin
export default {"container":"Textarea_container__Cra0w","inputFocus":"Textarea_inputFocus__TBcYS"};